import { useCallback, useState } from 'react';
import { Tooltip } from '@mantine/core';
import { IconBolt } from '@tabler/icons-react';
import { TABLE_ACTION_TOOLTIP_PROPS, TooltipTarget } from './TableActionIcon';

export default function ElectriqueIcon({ size = 16, title = 'Électrique' }) {
  const [opened, setOpened] = useState(false);
  const show = useCallback(() => setOpened(true), []);
  const hide = useCallback(() => setOpened(false), []);

  return (
    <Tooltip label={title} opened={opened} {...TABLE_ACTION_TOOLTIP_PROPS}>
      <TooltipTarget onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
        <IconBolt size={size} stroke={1.75} color="#f59f00" aria-hidden />
      </TooltipTarget>
    </Tooltip>
  );
}
